<h2 mat-dialog-title class="mat-h2">
  Test Information
  <button mat-icon-button class="close-button" type="button" aria-label="Close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <section class="dialog-section" aria-labelledby="test-properties-title">
    <h3 id="test-properties-title" class="dialog-section-title">Test Properties</h3>
    <dl class="test-properties">
      <div>
        <dt>No. of Probes</dt>
        <dd>{{ formatValue(data.noOfProbes) }}</dd>
      </div>
      <div>
        <dt>Linear Resistance</dt>
        <dd>{{ formatValue(data.linearResistance, 'Ω/cm') }}</dd>
      </div>
      <div>
        <dt>Effective Length</dt>
        <dd>{{ formatValue(data.effectiveLength, 'cm') }}</dd>
      </div>
      <div>
        <dt>Effective Radius</dt>
        <dd>{{ formatValue(data.effectiveRadius, 'cm') }}</dd>
      </div>
    </dl>
  </section>

  <section class="dialog-section" aria-labelledby="stages-title">
    <h3 id="stages-title" class="dialog-section-title">Stages</h3>
    @if (data.stages.length) {
      <div class="stages-table-container">
        <table mat-table [dataSource]="data.stages" class="stages-table">
          <ng-container matColumnDef="stageNumber">
            <th mat-header-cell *matHeaderCellDef class="numeric-cell">Stage</th>
            <td mat-cell *matCellDef="let stage" class="numeric-cell">{{ stage.stageNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="powerLevel">
            <th mat-header-cell *matHeaderCellDef class="numeric-cell">Power Level (W/cm)</th>
            <td mat-cell *matCellDef="let stage" class="numeric-cell">{{ formatValue(stage.powerLevel) }}</td>
          </ng-container>
          <ng-container matColumnDef="samplingRate">
            <th mat-header-cell *matHeaderCellDef class="numeric-cell">Sampling Rate (s)</th>
            <td mat-cell *matCellDef="let stage" class="numeric-cell">{{ formatValue(stage.samplingRate) }}</td>
          </ng-container>
          <ng-container matColumnDef="startTime">
            <th mat-header-cell *matHeaderCellDef class="numeric-cell">Start Time (s)</th>
            <td mat-cell *matCellDef="let stage" class="numeric-cell">{{ formatValue(stage.startTime) }}</td>
          </ng-container>
          <ng-container matColumnDef="endTime">
            <th mat-header-cell *matHeaderCellDef class="numeric-cell">End Time (s)</th>
            <td mat-cell *matCellDef="let stage" class="numeric-cell">{{ formatValue(stage.endTime) }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="stageColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: stageColumns"></tr>
        </table>
      </div>
    } @else {
      <p>No stages in this file.</p>
    }
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
